import Buildings from './Buildings';

export default Buildings;



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/Content/Buildings/index.js